// Imports
import React, { useEffect, useState } from 'react';
import { l } from '../../lang';
import { supabase } from '../../utils/supabase.js';

export default function PageHero({ lang }) {
    const [contentMap, setContentMap] = useState(null);

    useEffect(() => {
        supabase.from('menu_content').select('fr, en').eq('key', 'contact').single()
            .then(({ data }) => { if (data) setContentMap(data); });
    }, []);

    const title = contentMap?.[lang] || l('contact', lang);

    return (
        <div className='section section-page-hero'>
            <div className='page-hero'>
                <div className='page-hero-content'>
                    <h1 className="h1">{title}</h1>
                </div>
            </div>
        </div>
    )
}
